import React, { useState } from "react";
import axios from "axios";
import config from "../config";

const AddDownloadResources = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!title.trim()) validationErrors.title = "Title is required";
    if (!message.trim()) validationErrors.message = "Message is required";
    if (!file) validationErrors.file = "File is required";
    else if (file.type !== "application/pdf")
      validationErrors.file = "Only PDF files are allowed";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("catId", 5); // your category ID for Download Resources
      formData.append("prayerType", "download");
      formData.append("title", title);
      formData.append("description", message); // optional
      formData.append("file", file);

      const response = await axios.post(
        `${config.BASE_URL}/apis/create-post-admin`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        alert("Downloadable resource created successfully!");
        setTitle("");
        setMessage("");
        setFile(null);
        setErrors({});
      } else {
        alert("Failed to create resource: " + response.data.message);
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("An error occurred while uploading.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white shadow-md rounded-md">
      <div className="bg-orange-500 text-white px-4 py-3 rounded-t-md">
        <h2 className="font-semibold">Add New Downloadable Resource</h2>
      </div>

      <div className="p-6">
        <form onSubmit={handleSubmit} noValidate>
          {/* Title */}
          <div className="mb-4">
            <label htmlFor="title" className="block text-gray-700 font-medium mb-1">
              Title
            </label>
            <input
              id="title"
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.title ? "border-red-500" : "border-gray-300"
              }`}
              required
            />
            {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
          </div>

          {/* Message */}
          <div className="mb-4">
            <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
              Message
            </label>
            <textarea
              id="message"
              placeholder="Enter Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.message ? "border-red-500" : "border-gray-300"
              }`}
              rows={4}
              required
            />
            {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
          </div>

          {/* File Upload */}
          <div className="mb-6">
            <label htmlFor="file" className="block text-gray-700 font-medium mb-1">
              Upload PDF
            </label>
            <input
              id="file"
              type="file"
              accept="application/pdf"
              onChange={(e) => setFile(e.target.files[0])}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.file ? "border-red-500" : "border-gray-300"
              }`}
              required
            />
            {errors.file && <p className="text-red-500 text-sm mt-1">{errors.file}</p>}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="bg-orange-500 text-white font-semibold px-6 py-2 rounded hover:bg-orange-600 transition"
          >
            {loading ? "Uploading..." : "Add"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddDownloadResources;
